import { Tooltip } from '@mantine/core';
import { LegendColor, LegendItem, LegendList, LegendValue } from './LegendStyle';

interface LegendPropsType {
  legend: {
    color: string;
    value: any;
  }[];
  colorRadius?: string;
}

const Legend = ({ legend, colorRadius = '50%' }: LegendPropsType) => {
  const handleValue = (value: string | any[]) => {
    if (typeof value === 'string') return value || 'No Value';
    return value.map((item) => item.name).join(', ');
  };

  const renderLegendItem = (el: { color: string; value: any }) => {
    const value = handleValue(el.value);
    return (
      <LegendItem key={el.color}>
        <LegendColor $color={el.color} $colorRadius={colorRadius} />
        <Tooltip label={value} withArrow transitionProps={{ transition: 'rotate-right' }}>
          <LegendValue>{value}</LegendValue>
        </Tooltip>
      </LegendItem>
    );
  };

  return (
    <LegendList>{legend.sort((a, b) => a.color?.localeCompare(b.color)).map((el) => renderLegendItem(el))}</LegendList>
  );
};

export default Legend;
